/**
 * Global toggle for terminal trace headers (0x06 · LUSTER / platform.init() / ↳ PAGE).
 * Driven by portal_branding.terminal_trace_enabled; defaults to true.
 * When false, pages should render simple labels instead of the trace pattern.
 */

import { useState, useEffect } from "react"

export const TERMINAL_TRACE_CHANGE_EVENT = "luster_terminal_trace_change"

let terminalTraceEnabled = true

export function getTerminalTraceEnabled(): boolean {
  return terminalTraceEnabled
}

export function setTerminalTraceOverride(value: boolean): void {
  if (terminalTraceEnabled === value) return
  terminalTraceEnabled = value
  window.dispatchEvent(new CustomEvent(TERMINAL_TRACE_CHANGE_EVENT, { detail: value }))
}

export function useTerminalTraceEnabled(): boolean {
  const [value, setValue] = useState(getTerminalTraceEnabled)

  useEffect(() => {
    const handler = () => setValue(getTerminalTraceEnabled())
    window.addEventListener(TERMINAL_TRACE_CHANGE_EVENT, handler)
    return () => window.removeEventListener(TERMINAL_TRACE_CHANGE_EVENT, handler)
  }, [])

  return value
}
